<template>
    <section v-if="showAdvantage">
        <div class="xs-grid-cols-1 grid" data-nosnippet>
            <div class="f4 text-bold">{{ molang('search.advantage.title') }}</div>
            <div>
                {{ summaryText }}
                <span v-for="(link, index) in seoLinkItems" :key="link.href">
                    <a class="link" :href="link.href">{{ link.text }}</a>{{ index < seoLinkItems.length - 1 ? ', ' : '.' }}
                </span>
            </div>
            <div v-if="isStateSearch">
                <div class="text-bold">{{ molang('search.seo.paragraphTitle') }}</div>
                <div>{{ molang('search.advantage.otherParagraph', { stateFullName: getStateFullName }) }}</div>
            </div>
        </div>
    </section>
</template>

<script src="./advantage.js"></script>

<style lang="scss">
@use "./advantage.scss" as *;
</style>
